import { useMutation } from "@tanstack/react-query";
import { useRef } from "react";
import { useQueryClient } from "@tanstack/react-query";

import { SEO_SLUG_CACHE_KEYS } from "./keys";

import { AddSeoSlug } from "@/types/seo-slug";
import { SeoSlugRepository } from "@/repositories/seo-slug";

export const useAddSeoSlug = () => {
  const seoSlugRepository = useRef(new SeoSlugRepository());
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: AddSeoSlug) => {
      return seoSlugRepository.current.add(data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [SEO_SLUG_CACHE_KEYS.LIST, {}],
      });
    },
  });
};
